import React, { ChangeEvent } from "react";
import { Label } from "../Label";
import { CheckboxInput } from "../Checkboxes/CheckboxInput";
import { TextInput } from "../TextInput";
import { Field } from "../Field";
import { Error } from "../Error";
import { sanitiseString } from "../../Utils/StringUtils";

export interface Props {
  id: string;
  label: React.ComponentProps<typeof Label>;
  name?: string;
  marginTop?: number;
  onChange?: (event: ChangeEvent<HTMLInputElement>, ...args: unknown[]) => void;
  value?: string;
  autoFocus?: boolean;
  classes?: string;
  fieldId?: string;
  fieldClasses?: string;
  dataTestId: string;
  showPasswordText?: string;
  error?: React.ComponentProps<typeof Error>;
}

export const Password = (props: Props) => {
  const sanitiseId = sanitiseString(props.id);
  const sanitiseDataTestId = sanitiseString(props.dataTestId);

  const [password, showPassword] = React.useState(false);

  const togglePassword = () => {
    showPassword((prevPassword) => !prevPassword);
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (props.onChange !== undefined) {
      props.onChange(event, event.target.value);
    }
  };

  const renderPassword = () => {
    return (
      <>
        <Label
          for={sanitiseId}
          text={props.label.text}
          classes={props.label.classes}
          description={props.label.description}
        />
        <CheckboxInput
          id={sanitiseId + "-toggle"}
          classes="ons-checkbox--toggle"
          name="show-password"
          label={{ text: props.showPasswordText || "Show password" }}
          onClick={togglePassword}
          checked={password}
          dataTestId={sanitiseDataTestId + "-show-password"}
        />
        <TextInput
          id={sanitiseId}
          name={props.name}
          value={props.value}
          type={password ? "text" : "password"}
          classes="ons-input ons-input--text ons-input-type__input ons-u-mt-xs"
          onChange={(e) => handleChange(e)}
          dataTestId={sanitiseDataTestId + "-password-input"}
        />
      </>
    );
  };

  return (
    <Field
      id={sanitiseString(props.fieldId)}
      classes={props.fieldClasses}
      spellCheck={false}
      dataTestId={"field-" + sanitiseDataTestId}
      error={props.error}
    >
      {renderPassword()}
    </Field>
  );
};
